import Header from "./Header";
import Footer from "./Footer";
import Content from "./Content";
import { Outlet, useLocation } from "react-router-dom";
import NoticePopupList from "../components/notice/NoticePopupList";
import { POPUP_TARGET } from "../services/NoticePopupUtil";

/**
 * 메인(홈) 화면 경로. 상단 로고와 Header의 Home 링크가 이 경로로 이동한다(Header.jsx:40,49).
 * 팝업 공지의 `메인 화면` 노출 대상은 이 경로를 기준으로 한다.
 */
export const MAIN_SCREEN_PATH = "/pdi-status/regional-record";

const MainLayout = () => {
  const { pathname } = useLocation();
  const isMainScreen = pathname === MAIN_SCREEN_PATH;

  return (
    <>
      <Header />
      <Content>
        <Outlet />
      </Content>
      <Footer />
      {/*
        메인 화면 진입 시에만 팝업 공지를 표출한다.
        경로를 벗어나면 언마운트되고 다시 진입하면 재조회되므로 '메인 화면 진입 시' 동작이 된다.
        닫은 공지는 세션 내 재표출되지 않아 반복 진입해도 다시 뜨지 않는다.
      */}
      {isMainScreen && <NoticePopupList target={POPUP_TARGET.MAIN} />}
    </>
  );
};

export default MainLayout;
